import { flattenOrganizations } from './company/shared'
import type { CompanyStructure, Organization } from './company/types'
import type { ImportOfficeTarget, OfficeSelectOption } from '../../lib/import-upload'
import { officeOptionKey } from '../../lib/import-upload'

export type { ImportOfficeTarget, OfficeSelectOption } from '../../lib/import-upload'
export { officeOptionKey }

export const DEALER_ORG_TYPE_NAME = 'Дилер'
/** Кабинеты, созданные до смены bootstrap, имеют тип «Головной офис». */
export const ORDERS_IMPORT_ORG_TYPE_NAMES = ['Дилер', 'Головной офис'] as const

export function isDealerOrganization(org: Organization): boolean {
  return org.type_name === DEALER_ORG_TYPE_NAME
}

export function isOrdersImportOrganization(org: Organization): boolean {
  // Без типа (часто у свежих кабинетов) — не блокируем импорт.
  if (!org.type_name) return true
  return (ORDERS_IMPORT_ORG_TYPE_NAMES as readonly string[]).includes(org.type_name)
}

export function flattenOfficeOptions(
  structure: CompanyStructure,
  filterOrg?: (org: Organization) => boolean,
): OfficeSelectOption[] {
  const orgs = flattenOrganizations(structure)
  const options: OfficeSelectOption[] = []
  for (const org of orgs) {
    if (filterOrg && !filterOrg(org)) continue
    const typeSuffix = org.type_name ? ` · ${org.type_name}` : ''
    for (const office of org.offices) {
      options.push({
        officeId: office.id,
        organizationId: org.id,
        label: `${org.name} → ${office.name}${typeSuffix}`,
      })
    }
  }
  return options
}

export function flattenOfficeOptionsForUsers(structure: CompanyStructure): OfficeSelectOption[] {
  return flattenOfficeOptions(structure)
}

export function flattenOfficeOptionsForOrders(structure: CompanyStructure): OfficeSelectOption[] {
  return flattenOfficeOptions(structure, isOrdersImportOrganization)
}

export function hasDealerOffices(structure: CompanyStructure): boolean {
  return flattenOfficeOptionsForOrders(structure).length > 0
}

export function findOrgByOfficeId(
  structure: CompanyStructure,
  officeId: number,
): Organization | null {
  for (const org of flattenOrganizations(structure)) {
    if (org.offices.some(o => o.id === officeId)) {
      return org
    }
  }
  return null
}

export function defaultImportOfficeTarget(
  options: OfficeSelectOption[],
): ImportOfficeTarget | null {
  if (!options.length) return null
  return {
    organizationId: options[0].organizationId,
    officeId: options[0].officeId,
  }
}
